var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty_wrap",style:('height:' + _vm.h)},[_c('img',{attrs:{"src":require("@/assets/images/common/loading-bubbles.svg"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.tips || _vm.$t('hardLoading')))])])}
var staticRenderFns = []

export { render, staticRenderFns }